<!-- DetailHeader.vue -->
<template>
	<div class="ui-detail-header">
		<img class="left" src="../../assets/image/change-icon/back@2x.png" v-on:click='goBack()'>
		<div class="navbar-wrapper">
			<div v-for="(item, key) in data" v-bind:class="{'navbar_active': key == index}" v-on:click='changeEvent(key)'>{{item.name}}</div>
		</div>
		<img class="right" src="../../assets/image/change-icon/share@2x.png" v-on:click='share()'>
		<div class="dialog-wrapper" v-if="isDialog">
			<div class="top">
				<img class="box_item" src="../../assets/image/profile/xiao@2x.png" />
			</div>
			<div class="box">
				<img @click="shareContent('0')" class="box_item" src="../../assets/image/profile/weixin@2x.png" />
				<img @click="shareContent('1')" class="box_item" src="../../assets/image/profile/pengyouquan@2x.png" />
				<img @click="shareContent('2')" class="box_item" src="../../assets/image/profile/QQ@2x.png" />
				<img @click="shareContent('3')" class="box_item" src="../../assets/image/profile/QQkongjian@2x.png" />
				<div>选择分享方式</div>
			</div>
			<div class="footer">
				<img  @click="()=>{this.isDialog =false}" class="box_item" src="../../assets/image/profile/close@2x.png" />
			</div>
		</div>
	</div>
</template>

<script>
import { header } from './static';
import { mapState, mapMutations } from 'vuex'
export default {
	data(){
		return {
			data: header,
			isDialog:false
		}
	},

	computed: {
		...mapState({
			detailInfo: state => state.detail.detailInfo,
			index: state => state.detail.index
		})
	},

	created(){},

	methods: {
		...mapMutations({
			'changeIndex': 'changeIndex',
		}),

		changeEvent(index) {
			this.changeIndex(index);
		},

		goBack() {						
			this.$router.go(-1);			
		},
		share(){
			this.isDialog =true
		},
		shareContent(platform){
			// 参数都为string类型
			// platform 分享的平台 string类型 0 微信、1朋友圈、2 QQ、3QQ空间
			// title    分享的标题 string类型
			// subtitle 分享的副标题 string类型
			// icon     分享的图标链接 string类型
			// url      分享的内容链接 string类型
			let title =  this.detailInfo.name || '华联超市_app分享_标题'
			let subtitle = '我在华联超市发现了一个不错的商品,赶快来看看吧'
			let icon = 'http://premall.bestegou.com/images/share_logo.png'
			let url = window.location.href;
			if(window.android){
				window.android.shareContent(platform,title,subtitle,icon,url)
			}else if(window.webkit){
				window.webkit.messageHandlers.shareContent.postMessage({platform,title,subtitle,icon,url});
			}else if(window.wx){
				wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
					wx.updateAppMessageShareData({ 
						title: title, // 分享标题
						desc: subtitle, // 分享描述
						link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
						imgUrl: icon, // 分享图标
						success: function () {
								// 设置成功
						}
					})
				});
			}
		}
	}
}

</script>

<style lang='scss'>
	.ui-detail-header {
		padding: 0px 9px;
		height:44px;
		background:rgba(255,255,255,1);
		border-bottom: 0.5px solid rgba(232,234,237,1);
		color: #55595F;
		font-size: 17px;
		width: auto;
		display: flex;
		justify-content: center;
		align-content: center;
		align-items: center;
	    flex-basis: auto;
	    position: absolute;
	    top: 0px;
	    left: 0px;
	    right: 0px;
		.left {
			width: 24px;
			height: 24px;
			cursor: pointer;
			position: absolute;
			left: 9px;
			top: 10px;
		}
		.right {
			width: 24px;
			height: 24px;
			cursor: pointer;
			position: absolute;
			right: 9px;
			top: 10px;
		}
		.dialog-wrapper{
			z-index: 2000;
			position: fixed;
			top: 0;
			left: 0;
			width: 100vw;
			height: 100vh;
			overflow: hidden;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: center;
			background-color:rgba(0, 0, 0, 0.5);
			padding-top:20vh;
			.top{
				margin-bottom: -10vw;
				img{
					width: 20vw;
					height: 20vw;
				}
				z-index: 3000;
			}
			.box{
				border-radius: 6vw;
				padding-top:14vh;
				padding-bottom: 2vh;
				width: 80vw;
				height: 16vh;
				background-color:#ffffff;
				text-align: center;
				img{
					width: 12vw;
					height: 12vw;
					padding-left:2vw;
					padding-right: 2vw; 
				}
				div{
					color:#4E545D;
					margin-top: 6vw;
					font-size: 4vw;
				}
			}
			.footer{
				margin-top: 4vw;
				img{
					width: 12vw;
					height: 12vw;
				}
			}
		}
		div.navbar-wrapper {
			div {
	    		line-height: 42px;
	    		border-bottom: 0px;
	    		display: inline-block;
	    		margin-right: 48px;
	    		color: #55595F;
	    		background-color: #fff;
				&.navbar_active {
					color: $primaryColor;
					border-bottom: 2px solid $primaryColor;
				}
				&:last-child {
					margin-right: 0px;
				}
				&:focus {
					outline: none;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/page/product-detail/DetailHeader.vue